<app-layout-crud-index
  table
  [titulo]="title"
  [length]="length"
  [dataSource]="dataSource"
  [filterFields]="filterFields"
  [configColumns]="configColumns"
  [displayedColumns]="displayedColumns"
  (onChangePage)="changePage($event)"
  (onFilter)="filter($event)"
  (onSubmitAdvancedFilter)="submitAdvancedFilter($event)"
  (onOpenShow)="openShow($event)"
  (onOpenNew)="openNew($event)"
  (onOpenEdit)="openEdit($event)"
  (onOpenDelete)="openDelete($event)"
  (onResetFilter)="resetFilter()"
>
  <table-responsive-trainings 
    table
    [dataSource]="dataSource"
    [length]="length"
    [hasAdd]="true"
    [currentTab]="currentTab"
    [userType]="userType"
    [loadingDownloads]="loadingDownloads"
    [loadingProgress]="loadingProgress"
    
    [isEditableShow]="permissionService.is(permissionService.systemActionRoles.TRAINING_EDIT_BUTTON_SHOW)"
    [isEditableEnabled]="permissionService.is(permissionService.systemActionRoles.TRAINING_EDIT_BUTTON_ENABLED)"
    [isDeletableShow]="permissionService.is(permissionService.systemActionRoles.TRAINING_DELETE_BUTTON_SHOW)"
    [isDeletableEnabled]="permissionService.is(permissionService.systemActionRoles.TRAINING_DELETE_BUTTON_ENABLED)"
    [isLockActionShow]="false"
    [isLockActionEnabled]="true"
    
    [showLock]="false"
    [showDownload]="true"
    [showDescription]="true"
    [showPlayButton]="true"
    [lockProperty]="'isActive'"
    
    (changePage)="changePage($event)"
    (filter)="handleTrainingFilter($event)"
    (openShow)="openShow($event)"
    (openNew)="openNew($event)"
    (openEdit)="openEdit($event)"
    (openDelete)="openDelete($event)"
    (lock)="lock($event)"
    (unlock)="unlock($event)"
    (download)="downloadFile($event)"
    (cancelDownload)="cancelDownload($event)"
    (description)="showDescriptionFile($event)"
    (play)="handlePlay($event)"
    (resetFilter)="resetFilter()">
  </table-responsive-trainings>
  <div footer>
    <div fxFlex fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4">
      <div fxFlex></div>
      <div fxFlex>
        <button disabled class="action-button" mat-raised-button></button>
      </div>
      <div fxFlex>
        <button disabled class="action-button" mat-raised-button></button>
      </div>
      <div fxFlex>
        <button disabled class="action-button" mat-raised-button></button>
      </div>
      <div fxFlex></div>
    </div>
  </div>
</app-layout-crud-index>
